// Column min widths - columns use percentage sizing floored by these values
export const CUSTOMER_COLUMN_MIN_WIDTH = 160;
export const ACCOUNT_ID_COLUMN_MIN_WIDTH = 110;
export const OUTSTANDING_COLUMN_MIN_WIDTH = 150;
export const INVOICES_COLUMN_MIN_WIDTH = 90;
export const PAYMENT_METHOD_COLUMN_MIN_WIDTH = 150;
export const AUTOPAY_COLUMN_MIN_WIDTH = 90;
export const PAYMENT_PLAN_COLUMN_MIN_WIDTH = 130;
export const STATEMENT_COLUMN_MIN_WIDTH = 110;
export const CONTACT_INFO_COLUMN_MIN_WIDTH = 130;
